<template>
  <div class="hall">
    <HeadBar /><!--顶部bar-->
    <HeadNav /><!-- 顶部导航-->
    <div class="hall-inner">
      <div class="hall-center flex">
        <div class="hall-left">
          <div>
            <CateSelect @typeClick="typeClick" />
            <div class="hall-search">
              <SearchBarCircle
                :num="totalItem"
                v-model="searchKey"
                @btnClick="searchBarClick"
                placeholder="请输入关键字"
              />
            </div>
            <div v-loading="listLoading" class="hall-pros">
              <div>
                <CheckProject
                  v-for="(product, index) in products"
                  :key="index"
                  :info="product"
                />
              </div>
            </div>
          </div>
          <!-- 分页-->
          <Pagination
            :total="totalItem"
            :page="page"
            @pageIndexChange="handlePageChange"
          />
        </div>

        <!-- 特色能力 -->
        <HeatCapability class="flex-1" />
      </div>
    </div>
    <FootBar class="footer" />
  </div>
</template>
<script>
import { abilityList } from "@/api/hall";
import Pagination from "@/components/Pagination/index";
import SearchBarCircle from "@/components/SearchBarCircle/index";
import CateSelect from "./components/CateSelect.vue";
import CheckProject from "./components/CheckProject";
import HeatCapability from "./components/HeatCapability.vue";
export default {
  components: {
    Pagination,
    CateSelect,
    CheckProject,
    SearchBarCircle,
    HeatCapability,
  },
  data() {
    return {
      totalItem: 0,
      page: {
        pageIndex: 1,
        pageSize: 6,
      },
      products: [],
      queryTypeIds: {},
      listLoading: true,
      searchKey: "",
    };
  },
  methods: {
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.queryList();
    },
    // 类别点击
    typeClick(ids) {
      this.queryTypeIds = ids;
      this.queryList();
    },
    // 检索bar点击查询
    searchBarClick() {
      this.page.pageIndex = 1;
      this.queryList();
    },
    async queryList() {
      this.listLoading = true;
      this.products = [];
      const params = {
        ...this.page,
        searchKey: this.searchKey,
        abilityType: 0, //0：首页用户，1：实验室
      };
      const { firstTypeId, secondTypeId } = this.queryTypeIds;
      if (secondTypeId) {
        Object.assign(params, { secondTypeId });
      } else Object.assign(params, { firstTypeId });
      const { list, totalItem } = await this.$axios.post(abilityList, params);
      this.totalItem = totalItem;
      this.products = list || [];
      this.listLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.hall {
  &-inner {
    background: $home-bg;
    padding: 20px 0;
  }
  &-center {
    min-height: 400px;
    width: $max-width;
    margin: 0 auto;
  }
  &-left {
    width: 920px;
    margin-right: 16px;
  }
  &-search {
    border-top: 1px solid #f3f3f3;
    background: white;
    padding: 15px 20px;
    margin-bottom: 20px;
  }
  &-pros {
    min-height: 500px;
    > div {
      margin-bottom: 20px;
      // display: grid;
      // grid-template-columns: repeat(2, calc(50% - 8px));
      // gap: 15px;
    }
  }
}
.footer {
  padding-top: 0 !important;
}
</style>
